<template>
  <div>
    <v-row>
      <v-col cols="12" sm="3" offset-sm="6" class="py-0">
        <v-text-field
          v-model="search"
          color="dw_green"
          label="Search"
          clearable
          :clear-icon="mdiClose"
          single-line
          hide-details
          class="text-caption">
          <template v-slot:append>
            <v-icon small class="ml-1" v-text="mdiLayersSearchOutline" />
          </template>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="9">
        <v-data-table
          dense
          :headers="headers"
          :items="objectiveOptions"
          :search="search"
          item-key="id"
          :single-select="true"
          @click:row="(rowItem) => selectObjective(rowItem)"
          class="my-2"
          :footer-props="{
            showFirstLastPage: true,
            firstIcon: mdiPageFirst,
            lastIcon: mdiPageLast,
            prevIcon: mdiChevronLeft,
            nextIcon: mdiChevronRight
          }"
          :options="{
            itemsPerPage: 5
          }"
        >
        </v-data-table>
          <v-card flat color="bg_dark" v-if="selectedObjective">
            <v-card-title>{{ selectedObjective.title }}</v-card-title>
            <v-card-actions>
              <v-btn
                color="red"
                text
                @click="archive"
                title="Remove Objective">
                Remove
                <v-icon v-text="mdiArchiveOutline" small class="ml-2" />
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
  mdiArchiveOutline,
  mdiClose,
  mdiLayersSearchOutline,
  mdiPageFirst,
  mdiPageLast,
  mdiChevronLeft,
  mdiChevronRight
} from '@mdi/js';

export default {
  name: 'archiveObjectives',
  data() {
    return {
      mdiArchiveOutline,
      mdiClose,
      mdiLayersSearchOutline,
      mdiPageFirst,
      mdiPageLast,
      mdiChevronLeft,
      mdiChevronRight,
      search: '',
      headers: [
        { text: 'ID', value: 'id', class: 'font-weight-regular' },
        { text: 'Title', value: 'title', class: 'font-weight-regular' }
      ],
      items: undefined,
      selectedObjective: undefined,
      formValid: false
    };
  },
  computed: {
    ...mapGetters([
      'objectiveOptions'
    ])
  },
  methods: {
    ...mapActions([
      'archiveObjective',
      'fetchObjectiveOptions',
      'fetchOriginalByID'

    ]),
    async selectObjective(objective) {
      this.selectedObjective = await this.fetchOriginalByID(['objective', objective.id]);
    },
    async archive() {
      try {
        await this.archiveObjective({
          id: this.selectedObjective.id,
          title: this.selectedObjective.title,
          archived: true
        });
        this.selectedObjective = undefined;
        await this.fetchObjectiveOptions();
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>
